import { render, staticRenderFns } from "./cloud-server.vue?vue&type=template&id=2b1fee34&scoped=true"
import script from "./cloud-server.vue?vue&type=script&lang=js"
export * from "./cloud-server.vue?vue&type=script&lang=js"
import style0 from "./cloud-server.vue?vue&type=style&index=0&id=2b1fee34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fee34",
  null
  
)

export default component.exports